module.exports = __webpack_public_path__ + "img/birth_day_active.6ff61648.svg";